import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri';
import * as MdIcons from 'react-icons/md';
import * as AiIcons from 'react-icons/ai';
import * as GiIcons from 'react-icons/gi';

//menu para ADMIN-LMST
export const DataMenuJadmin = [
  {
    title: 'Mis Equipos',
    path: 'misequipos',
    icon: <RiIcons.RiGridFill />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Agregar Familia',
        path: 'misequipos/agregarfamilia',
        icon: <IoIcons.IoMdAddCircleOutline />
      },
      {
        title: 'Agregar Tipo',
        path: 'misequipos/agregartipo',
        icon: <IoIcons.IoMdAddCircleOutline />
      },
      {
        title: 'Agregar Marca',
        path: 'misequipos/agregarmarca',
        icon: <IoIcons.IoMdAddCircleOutline />
      },
      {
        title: 'Agregar Modelo',
        path: 'misequipos/agregarmodelo',
        icon: <IoIcons.IoMdAddCircleOutline />
      },
    ]
  },
  {
    title: 'Mis Clientes',
    path: 'clientes',
    icon: <FaIcons.FaUserNurse />,
  },
 
{
    title: 'Servicio Tecnico',
    path: 'serviciotecnico',
    icon: <MdIcons.MdSettings />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Orden de Ingreso',
        path: 'serviciotecnico/ingreso',
        icon: <IoIcons.IoIosCreate />
      }, {
        title: 'Items Mantencion',
        path: 'serviciotecnico/items',
        icon: <IoIcons.IoIosAlbums />
      },
      {
        title: 'Protocolos Mantencion',
        path: 'serviciotecnico/protocolos',
        icon: <IoIcons.IoIosAlbums />
      },
      {
        title: 'Items Servicio Tecnico',
        path: 'serviciotecnico/itemsst',
        icon: <IoIcons.IoIosAlbums />
      },
      {
        title: 'Protocolo Test Ingreso',
        path: 'serviciotecnico/protocolotest',
        icon: <IoIcons.IoIosApps />
      },
      {
        title: 'Asignar Ordenes',
        path: 'serviciotecnico/asignar',
        icon: <IoIcons.IoIosCreate />
      },
      {
        title: 'Mis Ordenes',
        path: 'serviciotecnico/asignadostecnicos',
        icon: <IoIcons.IoIosPaper />
      },
      {
        title: 'Entregas',
        path: 'serviciotecnico/entregas',
        icon: <AiIcons.AiOutlineDeliveredProcedure />
      },
      // {
      //   title: 'Baja Equipos',
      //   path: 'serviciotecnico/bajaequipos',
      //   icon: <AiIcons.AiOutlineDeliveredProcedure/>
      // },

    ]
  },
  {
    title: 'Reportes ST',
    path: 'reportesst',
    icon: <MdIcons.MdReport />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: 'Mant. Preventivo',
        path: 'reportesst/mantencionpreventiva',
        icon: <IoIcons.IoIosCreate />
      },
      {
        title: 'Presupuestos',
        path: 'reportesst/presupuestos',
        icon: <IoIcons.IoIosAlbums />
      },
      {
        title: 'Garantias',
        path: 'reportesst/garantias',
        icon: <GiIcons.GiTakeMyMoney />
      }
    ]
  },
 {
     title: 'Configuracion',
     path: 'configuracion',
     icon: <MdIcons.MdManageAccounts />,
     iconClosed: <RiIcons.RiArrowDownSFill />,
     iconOpened: <RiIcons.RiArrowUpSFill />,
 
     subNav: [
       {
         title: 'Usuarios y Roles',
         path: 'configuracion/registrausuarios',
         icon: <FaIcons.FaUserMd />
       }
       ,
     /*   {
         title: 'Alertas por usuario',
         path: 'configuracion/envios',
         icon: <MdIcons.MdEmail />
       }, */
       {
         title: 'Administrar Catalogos',
         path: 'configuracion/catalogos',
         icon: <MdIcons.MdEmail />
       }
     ]
   }
];
